// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"31a860aa687d0e82","432":"21b16acc2df888cd"}[chunkId] + ".js";
};